module.exports = __webpack_public_path__ + "static/media/29EUNOG13.4b5e0066.jpg";